module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-32-efe7b9c389a560ea37bc399c350d9e4e.svg";